import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { validateAccount } from '../../../services/account.service';
import { Box, Container, Grid, Paper, Typography } from '@material-ui/core';
import { CheckCircle } from '@material-ui/icons';
import Header from '../Header';
import { FormattedMessage } from 'react-intl';
import useStyles from './styles';
import messages from './messages';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const RealtorSignUpVerificationScreen = () => {
  const query = useQuery();
  const token = query.get('token');
  const [status, setStatus] = useState<
    'idle' | 'loading' | 'success' | 'error'
  >('idle');
  const [errorMessage, setErrorMessage] = useState('');

  const classes = useStyles();

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setErrorMessage(messages.noToken.defaultMessage);
      return;
    }
    setStatus('loading');
    const validateToken = async () => {
      try {
        const response = await validateAccount(token);
        if (response) {
          setStatus('success');
          setErrorMessage('');
        } else {
          setStatus('error');
          setErrorMessage(messages.invalidOrExpired.defaultMessage);
        }
      } catch (err) {
        setStatus('error');
        const errorMessage =
          typeof err === 'string'
            ? err
            : err instanceof Error
            ? err.message
            : messages.genericError.defaultMessage;
        setErrorMessage(errorMessage);
      }
    };
    validateToken();
  }, [token]);

  const successView = () => {
    return (
      <Box mt={2}>
        <Typography variant="subtitle1">
          <Box
            mb={2}
            display="flex"
            flexDirection="column"
            alignItems="center"
            gridRowGap={2}
          >
            <CheckCircle color="primary" style={{ fontSize: 60 }} />
            <FormattedMessage {...messages.success} />
          </Box>
        </Typography>
      </Box>
    );
  };

  return (
    <Box>
      <Header />
      <Box position="relative" pt={8} pb={8}>
        <Container maxWidth="xl" component="div" disableGutters>
          <Grid container justifyContent="center" alignItems="center">
            <Grid item xs={8} sm={6} md={4}>
              <Paper className={classes.paper} elevation={0} square>
                <Typography variant="h5">
                  <Box mb={2}>
                    <FormattedMessage {...messages.title} />
                  </Box>
                </Typography>
                <Typography variant="h6">
                  <Box mb={2}>
                    {status === 'loading' && (
                      <FormattedMessage {...messages.loading} />
                    )}
                    {status === 'success' && successView()}
                    {status === 'error' &&
                      (errorMessage || (
                        <FormattedMessage {...messages.genericError} />
                      ))}
                  </Box>
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default RealtorSignUpVerificationScreen;
